import React, {Component} from 'react';
import MatchWhenLoggedIn from '../MatchWhenLoggedIn'
import {Route, Redirect, Switch}  from 'react-router-dom'
import GareContent from '../gare/GareContent'
import CommesseContent from '../commesse/CommesseContent'
import DocumentiContent from '../documenti/DocumentiContent'
import AttivitaContent from '../attivita/AttivitaContent'
import MovimentiContent from '../movimenti/MovimentiContent'
import ReportContent from '../report/ReportContent'
import RubricaContent from '../rubrica/RubricaContent'
import ConfigurazioneContent from '../configurazione/ConfigurazioneContent'
import ProfiloUtenteContent from '../utenti/ProfiloUtenteContent'
import NewsContent from '../news/NewsContent'
import UtentiContent from '../utenti/UtentiContent'

class MainContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="sixteen wide column" id="content">
          <Switch>
            <MatchWhenLoggedIn path='/app/gare' component={GareContent} />
            <MatchWhenLoggedIn path='/app/commesse' component={CommesseContent} />
            <MatchWhenLoggedIn path='/app/documenti' component={DocumentiContent} />
            <MatchWhenLoggedIn path='/app/attivita' component={AttivitaContent} />
            <MatchWhenLoggedIn path='/app/movimenti' component={MovimentiContent} />
            <MatchWhenLoggedIn path='/app/rubrica' component={RubricaContent} />
            <MatchWhenLoggedIn path='/app/report' component={ReportContent} />
            <MatchWhenLoggedIn path='/app/configurazione' component={ConfigurazioneContent} />
            <MatchWhenLoggedIn path='/app/profiloutente' component={ProfiloUtenteContent} />
            <MatchWhenLoggedIn path='/app/news' component={NewsContent} />
            <MatchWhenLoggedIn path='/app/utenti' component={UtentiContent} />
              <Route exact path='/app' render={() => (
                  <Redirect
                      to='/app/attivita'
                  />
              )} />
          </Switch>
      </div>
    )
  }
}

export default MainContent;




/** WEBPACK FOOTER **
 ** ./src/components/main/MainContent.js
 **/